import { DateRange } from '../types';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

interface DateRangeFilterProps {
  dateRange: DateRange;
  onDateRangeChange: (range: DateRange) => void;
}

const DateRangeFilter = ({ dateRange, onDateRangeChange }: DateRangeFilterProps) => {
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onDateRangeChange({ ...dateRange, startDate: e.target.value });
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onDateRangeChange({ ...dateRange, endDate: e.target.value });
  };

  const handlePresetRange = (days: number) => {
    // End date is today (current date)
    const endDate = new Date();
    endDate.setHours(23, 59, 59, 999); // Set to end of today
    
    // Start date is (days - 1) days ago to include today in the count
    // e.g., "Last 7 Days" = today + 6 previous days = 7 days total
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - (days - 1));
    startDate.setHours(0, 0, 0, 0); // Set to start of day

    const newRange = {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0],
    };

    console.log('Setting date range:', newRange, 'for', days, 'days');
    onDateRangeChange(newRange);
  };

  return (
    <div className="bg-card rounded-md border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Date Range</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <Input
          label="Start Date"
          type="date"
          value={dateRange.startDate}
          onChange={handleStartDateChange}
          required
        />
        <Input
          label="End Date"
          type="date"
          value={dateRange.endDate}
          onChange={handleEndDateChange}
          required
        />
      </div>

      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => handlePresetRange(7)}
        >
          Last 7 Days
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => handlePresetRange(30)}
        >
          Last 30 Days
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => handlePresetRange(90)}
        >
          Last 90 Days
        </Button>
      </div>
    </div>
  );
};

export default DateRangeFilter;